import { Dispatch, FC, SetStateAction } from 'react';
import { HStack } from '@chakra-ui/react';

import { TeamMembersRequestStatus } from '__generated__/GQL';
import Chip from 'components/_core/Chip';

import locales from './locales';

interface StatusBarProps {
  status: TeamMembersRequestStatus[];
  onStatusChange: Dispatch<SetStateAction<TeamMembersRequestStatus[]>>;
}

const TABS = [
  {
    id: 'pending',
    title: locales.filters.pending,
    triggers: [TeamMembersRequestStatus.Pending],
  },
  {
    id: 'processing',
    title: locales.filters.processing,
    triggers: [
      TeamMembersRequestStatus.Approved,
      TeamMembersRequestStatus.Processed,
    ],
  },
  {
    id: 'done',
    title: locales.filters.done,
    triggers: [TeamMembersRequestStatus.Completed],
  },
  {
    id: 'canceled',
    title: locales.filters.canceled,
    triggers: [
      TeamMembersRequestStatus.Canceled,
      TeamMembersRequestStatus.Rejected,
    ],
  },
];

const StatusBar: FC<StatusBarProps> = ({
  onStatusChange,
  status: activeStatus,
}) => (
  <HStack spacing="space-16">
    {TABS.map((tab) => (
      <Chip
        isActive={activeStatus.some((s) => tab.triggers.includes(s))}
        key={tab.id}
        onClick={() => onStatusChange(tab.triggers)}
      >
        {tab.title}
      </Chip>
    ))}
  </HStack>
);

export default StatusBar;
